import React, { useEffect } from "react";
import { useLocation,useParams } from "react-router-dom";
import "./ServiceAreas.css";
import { Container, Row, Col, Navbar, Nav, Button, Card, Badge, ListGroup } from 'react-bootstrap';
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import Areas from "./Areas";

export default function ServiceAreas() {
  const location = useLocation();
  const { name } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: "ease-in-out",
      once: true,
      offset: 80,
    });
  }, []);

  const isAreaDetailPage = location.pathname.startsWith("/area/");

  return (
    <div className="Container-fluid">
           <section className="hero-section-wash-fold mt-5">
        <div className="hero-overlay-wash-fold mt-5">
          <Container fluid="xl" className="py-5 mt-4 h-100">
            <Row className="align-items-center justify-content-center text-center h-100 mt-5">
              <Col lg={8}>
                <h1 className="hero-title mb-4">
                Premium laundry & <br />
                  <span className="hero-highlight-wash-fold">
             dry cleaning services for {name || "Dubai & Abu Dhabi"}
                  </span> <br />
                
                </h1>
      
                <div className="d-flex justify-content-center flex-wrap gap-3 mt-4">
                  <button className="suhedule-btn-dark"
                  
                   onClick={() =>
    window.open(
      "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
      "_blank"
    )
  }>
                   <FaArrowRight /> Book Now
                  </button>
      
                  <button className="view-prices-list"  onClick={() => navigate("/laundry-price")}>
                    VIEW PRICE LIST
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/* <section className="serviceAreas-hero mt-4">
        <div className="serviceAreas-container px-4 mt-5" data-aos="fade-up">
         
          <div className="serviceAreas-left" data-aos="zoom-in-down">
            <h1 className="serviceAreas-brand mt-4">
               Premium laundry & dry cleaning services for {name || "Dubai & Abu Dhabi"}
            </h1>

            <div className="app-group">
              <button className="btn primary order-serviceAreas">
                <FaArrowRight /> Book Now
              </button>
            </div>

            <div className="app-group">
              <div className="store-btn ios">
                IOS App <span className="icon"></span>
              </div>

              <div className="store-btn android-serviceAreas">
                Android App <span className="icon">▶</span>
              </div>
            </div>
          </div>

       
          <div className="serviceAreas-right">
            <div className="circle-ring" data-aos="fade-down">
              <img
                src="https://5asec.ae/wp-content/uploads/2025/09/AreasHeader1.webp"
                alt="Model"
              />
            </div>
          </div>
        </div>
      </section> */}

      {!isAreaDetailPage && <Areas />}
    </div>
  );
}
